/**
 * Stato di una installazione, calcolato in base allo stato delle singole macchine
 */
export enum ServiceModeStatusEnum {
    Disabled = 0,
    Enabled = 1,
}

export function serviceModeStatusEnumLabel(status: ServiceModeStatusEnum): string {
    switch (status) {
        case ServiceModeStatusEnum.Disabled:
            return "enum.service_mode_status.disabled";
        case ServiceModeStatusEnum.Enabled:
            return "enum.service_mode_status.enabled";
        default:
            return "common.unknown";
    }
}
